import React from 'react';
import {IconButton} from '@mui/material';
import Tooltip from '../tooltip/Tooltip';
import PropTypes from 'prop-types';

const ButtonIcon = ({Icon = null, color, isFill = false, tooltipText = '', hideTooltip = false, onPress, style = {}, iconWidth = '24px', iconHeight = '24px', iconType = 'primary'}) => {
	return <>
		<Tooltip
            hideTooltip = {hideTooltip}
			content={tooltipText}
			type="basic"
			direction="bottom"
			style  = {{ width : 'auto'}}
		>
			<IconButton
                onClick = {() => onPress()}
				disableTouchRipple
				key={tooltipText}
				sx={{
					padding: '4px',
					borderRadius: '4px',
					width: '32px',
					height: '32px',
					border: 'none',
					'&:hover': {
						backgroundColor: color.button.primary_outline_hover,
					},
					'&:hover svg': {
						stroke: !isFill && color.icon.brand,
						fill : isFill && color.icon.brand
					},
					'& .MuiTouchRipple-root': {
						color: color.button.primary,
					},
					"& .MuiTouchRipple-root .MuiTouchRipple-child": {
						borderRadius: "4px"
					},
					...style
				}}
			>
                {Icon && isFill && <Icon fill = {color.icon[iconType]} style = {{width : iconWidth, height : iconHeight}} />}
                {Icon && !isFill && <Icon stroke = {color.icon[iconType]} style = {{width : iconWidth, height : iconHeight}} />}
            </IconButton>
	    </Tooltip>
	</>
}

export default ButtonIcon

ButtonIcon.propTypes = {
	Icon: PropTypes.string,
	color: PropTypes.object.isRequired,
	isFill : PropTypes.bool,
    tooltipText : PropTypes.string,
    hideTooltip : PropTypes.bool,
	onPress : PropTypes.func,
	style : PropTypes.object,
	iconWidth : PropTypes.string,
	iconHeight : PropTypes.string,
	iconType : PropTypes.oneOf(['primary', 'secondary', 'brand'])
};
